import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialActionsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCalloutsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective,
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import ConversionsModule from 'components/organisms/social/ConversionsModule';

class ConversionsContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'CONVERSIONS' } = {}) {
        super(props, objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
        this.props.fetchSocialAdSetsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
        this.props.fetchSocialCalloutsByObjective(payload);
    }

    render() {
        return (
            <ConversionsModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.getCurrentObjective()}
                layer={this.props.layer}
            />
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.CONVERSIONS,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export default connect(mapStateToProps, {
    fetchSocialActionsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCalloutsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective,
})(ConversionsContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/ConversionsContainer.js